
import 'antd/dist/antd.css';

import { Table } from 'antd';

import { rows } from './stockData';

const columns = [
  { title: 'Id', dataIndex: 'key', key: 'key', width: '10%', },
  { title: 'Product name', dataIndex: 'Item', key: 'Item' },
  { title: 'Price', dataIndex: 'Price', key: 'Price' },
  { title: 'Product Quantity', dataIndex: 'Quantity', key: 'Quantity',align: 'center' },
  { title: 'Product Item_revenue', dataIndex: 'Item_revenue', key: 'Item_revenue', align: 'center' },
  { title: 'Product Times_bought', dataIndex: 'Times_bought', key: 'Times_bought', align: 'center' },
  
  
 
];








function Ant() {
  return (
    <div className="Ant pb-5">
      <Table
    columns={columns}
    expandable={{
      expandedRowRender: record => <p style={{ margin: 0 }}><b>associations:</b> {record.Relations}</p>,
      rowExpandable: record => record.name !== 'Not Expandable',
    }}
    dataSource={rows}
  />
    </div>
  );
}

export default Ant;
